import React, { useEffect, useContext, useRef } from 'react';
import Authorized from '#AdminPanelFrontend/authorized/authorized';
import Unauthorized from '#AdminPanelFrontend/unauthorized/unauthorized';
import { socket } from '#AdminPanelFrontend/services/socket';
import { UserContext } from '#AdminPanelFrontend/contexts/UserContext';
import Cookies from 'js-cookie';
import moment from 'moment';

function App() {
	const { state } = useContext(UserContext);
	const socketInitialized = useRef(false);

	useEffect(() => {
		if (!socketInitialized.current) {
			socket.on('connect', () => {
				socket.off('connection');
				socket.on('connection', () => {
					const cookieState = Cookies.get('userStateAdmin');
					if (cookieState !== undefined) {
						const { username, lssk, validUntil } = JSON.parse(cookieState);
						if (moment(validUntil).unix() >= moment().unix()) {
							socket.timeout(5000).emit('User:Login', { username, lssk }, () => {});
						}
					}
				});
			});

			socket.on('disconnect', () => {});
		}

		return () => {
			socket.off('connect');
			socket.off('disconnect');
			socket.off('connection');
		};
	}, [state]);

	return state.isAuthorized ? <Authorized /> : <Unauthorized />;
}

export default App;
